import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import elistairLogo from '../../../../../assets/images/elistair-logo.png';
import navRight from '../../../../../assets/icons/navigate-right.svg';
import navLeft from '../../../../../assets/icons/navigate-left.svg';
import navRightMobile from '../../../../../assets/icons/navigate-right-mobile.svg';
import navLeftMobile from '../../../../../assets/icons/navigate-left-mobile.svg';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Ellipsis from 'react-ellipsis-component';
import cx from 'classnames';
import ReactGA from 'react-ga4';
import { gaPageView } from 'utils/ga';
import CustomHeader from 'app/components/CustomHeader';
import { IProduct } from '../../slice/types';
import { translations as _ } from '../../../../../locales/translations';
import { selectProductDetail } from '../../slice/selectors';
import { RootState } from 'types';
import { useDashboardSlice } from '../../slice';

export default function DetailLeftPart(props: any) {
  const { t } = useTranslation();
  const i18nKey = _.productDetail;
  const { actions } = useDashboardSlice();
  const dispatch = useDispatch();
  const location = useLocation<{ productCode: string }>();

  const [currentProductPosition, setCurrentProductPosition] = useState<
    number
  >();
  const [currentProductCode, setCurrentProductCode] = useState<string>(
    location.state.productCode,
  );
  const [prevProduct, setPrevProduct] = useState<IProduct>();
  const [nextProduct, setNextProduct] = useState<IProduct>();
  const [hasOverflow, setHasOverflow] = useState(false);
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const productList = useSelector(
    (state: RootState) => state.dashboard?.getProducts.data,
  );

  let { data: productDetail, loading: loadingProductDetail } = useSelector(
    selectProductDetail,
  );

  useEffect(() => {
    getProductDetail(currentProductCode);
    ReactGA.event({
      category: 'product detail view',
      action: 'view : ' + currentProductCode,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actions, dispatch, currentProductCode]);

  useEffect(() => {
    dispatch(actions.getProducts());
    gaPageView(window.location.pathname + window.location.search);
  }, [actions, dispatch]);

  function getProductDetail(productCode) {
    dispatch(actions.getProductDetail(productCode));
    setCurrentProductCode(productCode);
    setCurrentProductPosition(getProductIndex(productCode));
  }

  useEffect(() => {
    dispatch(actions.getGuidelineURL());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actions, dispatch]);

  useEffect(() => {
    getProductDetail(currentProductCode);
    ReactGA.event({
      category: 'product detail view',
      action: 'view : ' + currentProductCode,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actions, dispatch, currentProductCode]);

  useEffect(() => {
    if (!currentProductPosition) {
      setCurrentProductPosition(getProductIndex(currentProductCode));
    }

    if (productList && currentProductPosition !== undefined) {
      setPrevProduct(productList[currentProductPosition - 1]);
      setNextProduct(productList[currentProductPosition + 1]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentProductPosition, productList]);

  function getProductIndex(productCode) {
    return productList?.findIndex(obj => obj.product_code === productCode);
  }

  function onDescriptionClick() {
    if (hasOverflow || isDescriptionOpen) {
      setIsDescriptionOpen(!isDescriptionOpen);
    }
  }

  return (
    <div className="product-detail-intro">
      <CustomHeader addBack showLink={true} />
      <div className="product-detail-intro-north">
        <img alt="elistair-logo" src={elistairLogo} className="logo" />
        {!loadingProductDetail && (
          <>
            <h1>
              {productDetail?.translations[0]?.name ||
                productDetail?.product_code}
            </h1>
            <div className="container-3d">
              <img
                alt="product-3d"
                src={productDetail?.visual_3d}
                className="image"
              />
            </div>

            <h2>{productDetail?.translations[0]?.subtitle}</h2>
            <p>{productDetail?.translations[0]?.description}</p>
          </>
        )}
      </div>
      {productList && (
        <div className="product-detail-intro-south">
          <div
            className={cx('navigation', {
              hidden: !prevProduct,
            })}
            onClick={() => getProductDetail(prevProduct?.product_code)}
          >
            <img alt="left" src={navLeft}></img>
            <p>{prevProduct?.translations[0]?.name}</p>
          </div>
          <div
            className={cx('navigation', {
              hidden: !nextProduct,
            })}
            onClick={() => getProductDetail(nextProduct?.product_code)}
          >
            <img alt="right" src={navRight}></img>
            <p>{nextProduct?.translations[0]?.name}</p>
          </div>
        </div>
      )}
      <div className="product-detail-intro-mobile">
        <div className="product-detail-intro-mobile-north">
          <img
            alt="product-viual-3d"
            src={productDetail?.visual_3d}
            className="image"
          />
        </div>
        <div className="product-detail-intro-mobile-middle">
          <div
            className={cx('navigation', {
              hidden: !prevProduct,
            })}
            onClick={() => getProductDetail(prevProduct?.product_code)}
          >
            <img alt="left" src={navLeftMobile}></img>
          </div>
          <h1>
            {productDetail?.translations[0]?.name ||
              productDetail?.product_code}
          </h1>
          <div
            className={cx('navigation', {
              hidden: !nextProduct,
            })}
            onClick={() => getProductDetail(nextProduct?.product_code)}
          >
            <img alt="right" src={navRightMobile}></img>
          </div>
        </div>
        <div className="product-detail-intro-mobile-south">
          <h2>{productDetail?.translations[0]?.subtitle}</h2>

          <div className="description" onClick={onDescriptionClick}>
            <Ellipsis
              onReflow={ellipsis => setHasOverflow(ellipsis)}
              ellipsis
              text={productDetail?.translations[0]?.description || ''}
              maxLine={isDescriptionOpen ? 100 : 3}
            />
            {hasOverflow || isDescriptionOpen ? (
              <span className="ellipsis">
                {isDescriptionOpen ? t(i18nKey.less) : t(i18nKey.more)}
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
